import { z } from "zod";
import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";

export const DurationUnit = z.enum(["Ms"]);

export const DurationValue = z.object({
  unit: DimensionUnit,
  measure: z.number(),
});

export const DurationTokenData = tokenAliasOrValue(DurationValue);

export type DurationUnit = z.infer<typeof DurationUnit>;
export type DurationValue = z.infer<typeof DurationValue>;
export type DurationTokenData = z.infer<typeof DurationTokenData>;
